export default __webpack_public_path__ + "static/media/logo.3fc6bd69.svg";